import * as React from 'react'

import type moment from 'moment'

import { observer } from 'mobx-react'

import { dateToString } from 'modules/core/lib/dates'

import EmptyCellActions from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/CellActions/EmptyCellActions'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useSelectionState } from 'modules/shift_management/hooks/useSelection'
import type DefaultShifts from 'modules/shift_management/store/internal/collections/DefaultShifts'
import type ShiftsRow from 'modules/shift_management/store/internal/models/ShiftsRow'

interface EmptyCellProps {
  shiftsRow: ShiftsRow
  date: moment.Moment
  isOver: boolean
  visibleDefaultShifts: DefaultShifts
}

const EmptyCell = ({ date, shiftsRow, isOver, visibleDefaultShifts }: EmptyCellProps) => {
  // Keep these selection hooks here, using this wrapper to be re-rendered
  // but we avoid to re-render the children unless the isSelected prop changes.
  const { daysByRow } = useSelectionState()
  const [{ view }] = useSchedule()

  const dayId = dateToString(date, view.dateFormat)
  const isSelected = (daysByRow[shiftsRow.key] || []).includes(dayId)

  return (
    <EmptyCellActions
      date={date}
      shiftsRow={shiftsRow}
      isSelected={isSelected}
      isOver={isOver}
      visibleDefaultShifts={visibleDefaultShifts}
    />
  )
}

export default observer(EmptyCell)
